import type { Category, CategoryPosColor } from '@/lib/services/categories/categories.types'

export interface CategoryTileColorOption {
  value: CategoryPosColor
  label: string
  className: string
}

const ROSE_TILE_COLOR: CategoryTileColorOption = {
  value: 'rose',
  label: 'Rose',
  className:
    'border-status-destructive-border bg-status-destructive-background text-status-destructive-foreground hover:bg-status-destructive-background dark:border-status-destructive-border dark:bg-status-destructive-background dark:text-status-destructive-foreground',
}

/** A POS shortcut tile's colors, by the category's `pos_color`. */
export const CATEGORY_TILE_COLOR_OPTIONS: readonly CategoryTileColorOption[] = [
  ROSE_TILE_COLOR,
  {
    value: 'emerald',
    label: 'Emerald',
    className:
      'border-status-success-border bg-status-success-background text-status-success-foreground hover:bg-status-success-background dark:border-status-success-border dark:bg-status-success-background dark:text-status-success-foreground',
  },
  {
    value: 'amber',
    label: 'Amber',
    className:
      'border-status-warning-border bg-status-warning-background text-status-warning-foreground hover:bg-status-warning-background dark:border-status-warning-border dark:bg-status-warning-background dark:text-status-warning-foreground',
  },
  {
    value: 'sky',
    label: 'Sky',
    className:
      'border-sky-200 bg-sky-50 text-sky-950 hover:bg-sky-100 dark:border-sky-800/60 dark:bg-sky-950/30 dark:text-sky-50',
  },
  {
    value: 'fuchsia',
    label: 'Fuchsia',
    className:
      'border-fuchsia-200 bg-fuchsia-50 text-fuchsia-950 hover:bg-fuchsia-100 dark:border-fuchsia-800/60 dark:bg-fuchsia-950/30 dark:text-fuchsia-50',
  },
  {
    value: 'lime',
    label: 'Lime',
    className:
      'border-lime-200 bg-lime-50 text-lime-950 hover:bg-lime-100 dark:border-lime-800/60 dark:bg-lime-950/30 dark:text-lime-50',
  },
]

/** The tile colors for a shortcut; one without a color uses the first. */
export function getCategoryTileColorOption(
  category: Pick<Category, 'pos_color'> | null | undefined
): CategoryTileColorOption {
  return (
    CATEGORY_TILE_COLOR_OPTIONS.find((option) => option.value === category?.pos_color) ??
    ROSE_TILE_COLOR
  )
}
